import styled from 'styled-components';

export const StyledItem = styled.span`
    display: inline-block;
    height: 30px;
    line-height: 30px;
    background-color: ${({ theme }) => theme.colors.softBlue};
    color: ${({ theme }) => theme.colors.white};
    font-size: 13px;
    white-space: nowrap;
    padding: 0 8px;
    margin-right: 8px;
    margin-top: 10px;
`;
